import { SelectPropsValue } from 'commons/components';
import { AutomationRulesDropdown, AutomationRulesDropdownOptions } from '../automation-rules-dropdown.component';
import { BaseProps } from '../field-conditional.type';

export interface DropdownFieldProps extends BaseProps {
    name: string;
    placeholder?: string;
    options: AutomationRulesDropdownOptions[];
    defaultSelectedOption?: SelectPropsValue;
    type: string;
    virtualized?: boolean;
}

export const DropdownField: React.FC<DropdownFieldProps> = (props) => {
    const { name, placeholder, defaultSelectedOption, options, type, virtualized, onChange } = props || {};

    return (
        <AutomationRulesDropdown
            name={name}
            options={options}
            placeholder={placeholder}
            type={type}
            onChange={onChange}
            defaultSelectedOption={defaultSelectedOption}
            virtualized={virtualized}
        />
    );
};
